import Controller from "./editableAutocomplete.controller";
import template from "./editableAutocomplete.html";

const editableAutocomplete = {
  template,
  controller: Controller,
  bindings: {
    selected: "=",
    title: "@",
    resource: "@",
    eventName: "<",
    name: "@",
    index: "<",
    hideEdit: "<",
    isRequired: "<",
    state: "@",
    showRemove: "@",
    params: "<",
    permissionName: "@",
    resourceMethod: "@",
    resourceMethodName: "@",
    extraParams: "<",
    hideLinks: "<",
    onFieldChangeEvent: "<?",
    isDisabled: "<",
  },
};

export default editableAutocomplete;



// WEBPACK FOOTER //
// ./src/components/editableAutocomplete/editableAutocomplete.component.js